import React, {useEffect} from "react";
import {Card, Chip, DateTimeStandard, Typography} from '@curves/ui-base';
import {Overview} from '@curves/ui-shared';

import {formatCurrencyFn} from "@Util/utils";
import {parseDate} from "@Util/moment.util";
import {matchOrderPaymentStatusColors} from "@Local/CyclePurchase/staticData";
import useOrderCyclePurchaseApi from "@Apis/useOrderCyclePurchaseApi";
import useOverview from "@Util/hook/useOverview";

const CyclePurchaseDetailPayment = props => {
    const {memberID, cycleOrderID} = props;
    const {postMembersCyclePurchaseOrdersApi} = useOrderCyclePurchaseApi();
    const {overviewData, getOverviewData, updateOverviewPage} = useOverview({
        getOverviewApi: params => postMembersCyclePurchaseOrdersApi(memberID, cycleOrderID, params),
        defaultSearchParams: {pageIndex: 1, pageSize: 10},
        isFetchOnMount: false,
        enableQueryString: false,
    });

    const headerRow = [
        {
            cellKey: "orderDate",
            headerLabel: "日期",
            width: "15",
            align: "center",
            formatCell: (cellValue, rowData) => (
                <Typography>{parseDate(rowData?.orderDate, DateTimeStandard.DisplayDate)}</Typography>
            ),
        },
        {
            cellKey: "itemName",
            headerLabel: "品項",
            width: "25",
            formatCell: (cellValue, rowData) => (
                <Typography>{rowData?.itemName || "-"}</Typography>
            ),
        },
        {
            cellKey: "paymentStatus",
            headerLabel: "付款狀態",
            width: "15",
            align: "center",
            formatCell: (cellValue, rowData) => (
                <Chip label={rowData?.paymentStatusText || "-"}
                      color={matchOrderPaymentStatusColors(rowData?.paymentStatus || 0)} title={"付款狀態"}/>
            ),
        },
        {
            cellKey: "itemPrice",
            headerLabel: "金額",
            width: "15",
            align: "right",
            formatCell: (cellValue, rowData) => (
                <Typography>{formatCurrencyFn(rowData?.itemPrice || 0)}</Typography>
            ),
        },
        {
            cellKey: "notes",
            headerLabel: "備註",
            width: "15",
            align: "center",
            formatCell: (cellValue, rowData) => (
                <Typography>{rowData?.notes || "-"}</Typography>
            ),
        },
    ];

    useEffect(
        () => {
            if (memberID) {
                getOverviewData({pageIndex: 1, pageSize: 10});
            }
        },
        // eslint-disable-next-line
        [memberID, cycleOrderID]
    );

    return (
        <Overview contextValue={{overviewData, getOverviewData, updateOverviewPage}}>
            <Card className="p-4">
                <Overview.Table headerRow={headerRow}/>
                <Overview.Pagination className="mt-4" />
            </Card>
        </Overview>
    );
};

export default CyclePurchaseDetailPayment;
